import { Position } from 'geojson';
import { GeoJSON } from 'leaflet';
import * as actions from '../actions/index';
import styles from '../../composant/Vue/AffichageVue/AffichageVue.module.scss';

export const insertAndShift = (arr: any[], from: number, to: number) => {
  let cutOut = arr.splice(from, 1)[0];
  arr.splice(to, 0, cutOut);
  return arr;
};

export const affichageRetourErreurs = (
  dispatch: (action: any) => void,
  typeAlerte: string,
  titre: string,
  res: any
) => {
  if (res?.data?.errors && res.data.errors.length > 0) {
    for (let erreurKey = 0; erreurKey < res.data.errors.length; erreurKey++) {
      const idErreur = res.data.errors[erreurKey];

      // Gestion spéciale pour l'erreur 100006 (mot de passe incorrect)
      if (idErreur === 100006) {
        dispatch(
          actions.ajouterAlerte(
            'danger',
            'Email incorrect ou mot de passe incorrect.',
            'Email incorrect ou mot de passe incorrect.'
          )
        );
      }
      // Gestion spéciale pour l'erreur 100007 (email non trouvé)
      else if (idErreur === 100007) {
        dispatch(
          actions.ajouterAlerte(
            'danger',
            'Email incorrect ou mot de passe incorrect.',
            'Email incorrect ou mot de passe incorrect.'
          )
        );
      } else {
        dispatch(
          actions.ajouterAlerte(typeAlerte, titre, [
            'ApiEchecErreursEnBoucle',
            {
              numAvertissement: erreurKey,
              idErreur: idErreur,
            },
          ])
        );
      }
    }
  } else {
    dispatch(
      actions.ajouterAlerte(typeAlerte, 'Erreur', 'errors de connexion')
    );
  }
};

export const setUrlPathFromDomain = (
  pathForDev: string,
  pathForProd: string,
  defaultPath: string = pathForDev
): string => {
  if (document.domain === 'localhost') {
    return pathForDev;
  } else if (document.domain === 'argos-v19.itmsol.fr') {
    return pathForProd;
  } else {
    return defaultPath;
  }
};

export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  ms: number
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | undefined;

  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = undefined;
      fn(...args);
    }, ms);
  };
}

export const createGeoJSONCircle = (
  center: number[],
  radiusInKm: number,
  points: number
) => {
  if (!points) points = 64;

  var coords = {
    latitude: center[1],
    longitude: center[0],
  };

  var km = radiusInKm;

  var ret = [];
  var distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
  var distanceY = km / 110.574;

  var theta, x, y;
  for (var i = 0; i < points; i++) {
    theta = (i / points) * (2 * Math.PI);
    x = distanceX * Math.cos(theta);
    y = distanceY * Math.sin(theta);

    ret.push([coords.longitude + x, coords.latitude + y]);
  }
  ret.push(ret[0]);

  return {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [ret],
    },
  };
};

export const adjustValueToProvidedDistanceUnit = (
  valeur: number,
  unite: string
) => {
  unite = unite.trim().toLowerCase();
  switch (unite) {
    case 'km':
      return valeur;
    case 'm':
      return valeur / 1000;
    case 'dm':
      return valeur / 10000;
    case 'cm':
      return valeur / 100000;
    default:
      return valeur;
  }
};

export function projectLineString(lineString: {
  coordinates: Position[];
  properties: any;
}) {
  // Vérifie que les coordonnées sont valides
  if (
    !lineString ||
    !lineString.coordinates ||
    !Array.isArray(lineString.coordinates)
  ) {
    return null;
  }

  const isFiniteNumber = (value: any) => !isNaN(value) && isFinite(value);

  if (
    !lineString.coordinates.every(
      (coords) => Array.isArray(coords) && coords.every(isFiniteNumber)
    )
  ) {
    return null;
  }

  // Crée une nouvelle feature GeoJSON projetée
  const feature: GeoJSON.Feature = {
    type: 'Feature',
    properties: lineString.properties,
    geometry: {
      type: 'LineString',
      coordinates: lineString.coordinates,
    },
  };

  // Retourne une instance GeoJSON
  return new GeoJSON(feature);
}
const sensorColorArray = [
  { color: 'green', classColor: styles.SensorLevel_green },
  { color: 'blue', classColor: styles.SensorLevel_blue },
  { color: 'orange', classColor: styles.SensorLevel_orange },
  { color: 'red', classColor: styles.SensorLevel_red },
  { color: 'black', classColor: styles.SensorLevel_black },
];

export const getSensorColor = (index: any) => {
  if (typeof index === 'number') {
    return sensorColorArray[index]
      ? sensorColorArray[index]
      : { color: 'grey', classColor: styles.SensorLevel_grey };
  }
  return { color: 'grey', classColor: styles.SensorLevel_grey };
};

function convertiUtsToDate(utsArray: number[]) {
  return utsArray.map((uts: number) => {
    const date = new Date(uts * 1000); // Convertir UTS en millisecondes
    date.setHours(0, 0, 0, 0); // Ajuster à minuit
    return date;
  });
}

export function convertProjectData(projects: any[]) {
  return projects.map((project) => {
    return {
      name: project.project_name,
      yaxis: 'y1', // ou "y2", selon la logique de votre application
      type: 'bar',
      mode: 'lines',
      x: convertiUtsToDate(project.fails_list.time),
      y: project.fails_list.rates,
    };
  });
}
